export const SLIDER_SETTINGS = {
  CONTENT_CARDS: {
    fade: true,
    arrows: false,
    swipeToSlide: false,
    swipe: false,
    dots: false,
  },

  IMAGE_CARDS: {
    slidesToShow: 2,
    swipeToSlide: true,
    focusOnSelect: true,
    dots: true,
    arrows: true,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '18%',
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
  },
}
